import { memo } from 'react';
import { Icon } from '@amzn/awsui-components-core';

import styles from './ContentNavigator.module.scss';
import AddNewPageModal from './AddNewPageModal';
import { useAddNewPageButtonViewModel } from './AddNewPageButtonViewModel';

/** Icon button + modal for adding a new page to a Guide document. */
const AddNewPageButton = memo(function AddNewPageButton() {
  const vm = useAddNewPageButtonViewModel();

  return (
    <>
      <button
        type="button"
        className={styles.editIconButton}
        aria-label="Add Pages"
        onClick={vm.openModal}
      >
        <Icon name="add-plus" />
      </button>
      {vm.isModalVisible && <AddNewPageModal vm={vm} />}
    </>
  );
});

export default AddNewPageButton;
